require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-cdc-diagnosis.json") })
        }
      }, "path---article-cdc-diagnosis");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-cdc-diagnosis!./.cache/json/article-cdc-diagnosis.json
// module id = 333
// module chunks = 231608221292675